// extracted by mini-css-extract-plugin
export default {"container":"join-teams_container__F7JR0","person-container":"join-teams_person-container__T55Cn","buttonWrapper":"join-teams_buttonWrapper__5ITow"};